import { render, staticRenderFns } from "./contactDetailsView.vue?vue&type=template&id=7559b008&"
import script from "./contactDetailsView.vue?vue&type=script&lang=js&"
export * from "./contactDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports